import * as types from './mutation-types'

export const loadMeals = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('meals/collection').then((response) => {
            commit(types.ADD_MEALS, response.data.meals)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadMealSaleElements = ({commit, dispatch, state}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('mealSaleElements/collection').then((response) => {
            commit(types.ADD_MEAL_SALE_ELEMENTS, response.data.mealSaleElements)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadMeal = ({commit, dispatch, state}, meal_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`meals/${meal_id}/details`).then((response) => {
            commit(types.LOAD_MEAL, response.data.product)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateCategory = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/' + data.id + '/category', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createMeal = ({commit, dispatch, state}, data) => {
    let formData = new FormData()
    if(data.meal_id){
        formData.append('meal_id', data.meal_id)
    }
    formData.append('name', data.name)
    formData.append('price', data.price)
    formData.append('cooking_place', data.cooking_place)
    formData.append('online', data.online)
    formData.append('category_id', data.category_id)
    formData.append('duration', data.duration)
    formData.append('description', data.description)
    if(data.image){
        formData.append('image', data.image)
    }
    data.complements.forEach((complement, key) => {
        formData.append("accompaniments["+ key +"]", complement);
    })

    data.sale_element_with_attributes.forEach((mealSaleElement, key) => {
        formData.append("sale_element_with_attributes["+ key +"][id]", mealSaleElement.id);
        formData.append("sale_element_with_attributes["+ key +"][price]", mealSaleElement.price);
        formData.append("sale_element_with_attributes["+ key +"][online]", mealSaleElement.online);
    })

    data.attributs.forEach((attribut, key) => {
        if(attribut.attribut_id){
            formData.append("attributs["+ key +"][attribut_id]", attribut.attribut_id);
        }
        attribut.variations.forEach(variartion => {
            formData.append("attributs["+ key +"][variations][]", variartion);
        })
    })

    formData.append('_method', 'POST')

    return new Promise((resolve, reject) => {
        window.axios.post('store/meals', formData, data, {headers: {'Content-type': 'multipart/form-data'}}).then((response) => {
            commit(types.ADD_MEAL, response.data.meal)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteMealSaleElement = ({commit, dispatch, state}, meal_sale_element_id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`/mealSaleElements/${meal_sale_element_id}/delete`).then((response) => {
            //commit(types.LOAD_MEAL, response.data.product)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storeMealsWithFile = ({ commit, dispatch, state }, data) => {
    let formData = new FormData();
    formData.append('file', data.file);
    formData.append('_method', 'POST');
    return new Promise((resolve, reject) => {
        window.axios.post(`meals/imports`, formData, {headers: {'Content-type': 'multipart/form-data'}}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


